import React from 'react';
import { Metafields, Product } from '../../../types/ecommerce.types';
import { withQuery } from '../data/withQuery';
import ProductTypeVideo from './ProductTypeVideo';
import { useMediaQuery } from 'react-responsive';
import SectionTitle from '../shared/SectionTitle';

import * as S from './ProductDescription.styles';

const ProductAttributionDescriptionV2: React.FC<{
  shopMetafields: Metafields;
  product: Product;
}> = ({ product }) => {

  const isDesktop = useMediaQuery({ minWidth: 769 });

  const editorialSection = product?.editorial_section?.reference;
  const objHandle = editorialSection?.handle;
  const displayType = editorialSection?.displayType?.value;
  const displayTypeCase = displayType.toLowerCase();
  const sectionTitle = editorialSection?.sectionTitle?.value;
  const displayTitle = editorialSection?.displayTitle?.value;
  const sectionLogo = editorialSection?.sectionLogo?.reference?.image?.url || null;
  const sectionLogoAlt = editorialSection?.sectionLogo?.reference?.image?.altText || null;
  const imagePoster = editorialSection?.imagePoster?.reference?.image?.url || null;
  const videWEBM = editorialSection?.videWEBM?.value;
  const videoMP4 = editorialSection?.videoMP4?.value;
  const bodyContent = editorialSection?.bodyContent?.value;

  if (!product || !objHandle) {
    return null;
  }

  return (
    <S.Wrapper data-cy="product-description" id="attribution-description">
      <div className="tmplt-product">
        <S.FinePrint2>
          {displayTypeCase === 'image' && (
            <div>
              <img src={imagePoster ? imagePoster : null} alt="" />
            </div>
          )}
          {displayTypeCase === 'video' && (
            <div>
              <ProductTypeVideo
                videoMp4={videoMP4}
                videoWebm={videWEBM}
                videoPoster={imagePoster}
              />
            </div>
          )}
          <div>
            <div>
              {sectionLogo && (
                <p className="typo__header typo__header--large typo__header--bold">
                  <img src={sectionLogo} alt={sectionLogoAlt || sectionTitle} />
                </p>
              )}
              {displayTitle === 'true' && (
                <SectionTitle title={sectionTitle} style={{ maxWidth: isDesktop ? '100%' : 220 }} />
              )}

              <p
                dangerouslySetInnerHTML={{
                  __html: bodyContent ? bodyContent : null,
                }}
              />
            </div>
          </div>
        </S.FinePrint2>
      </div>
    </S.Wrapper>
  );
};

export default withQuery(ProductAttributionDescriptionV2);
